__turbopack_context__.v({
  "activeRoleCard": "Roles-module__-SQx9W__activeRoleCard",
  "benefitItem": "Roles-module__-SQx9W__benefitItem",
  "benefits": "Roles-module__-SQx9W__benefits",
  "bentoCard": "Roles-module__-SQx9W__bentoCard",
  "bentoGrid": "Roles-module__-SQx9W__bentoGrid",
  "bigMetric": "Roles-module__-SQx9W__bigMetric",
  "blueIcon": "Roles-module__-SQx9W__blueIcon",
  "container": "Roles-module__-SQx9W__container",
  "darkIcon": "Roles-module__-SQx9W__darkIcon",
  "eyebrow": "Roles-module__-SQx9W__eyebrow",
  "implementationCard": "Roles-module__-SQx9W__implementationCard",
  "integrationPill": "Roles-module__-SQx9W__integrationPill",
  "integrationPills": "Roles-module__-SQx9W__integrationPills",
  "integrationsContainer": "Roles-module__-SQx9W__integrationsContainer",
  "integrationsEyebrow": "Roles-module__-SQx9W__integrationsEyebrow",
  "integrationsSection": "Roles-module__-SQx9W__integrationsSection",
  "integrationsSubtitle": "Roles-module__-SQx9W__integrationsSubtitle",
  "integrationsTitle": "Roles-module__-SQx9W__integrationsTitle",
  "lightIcon": "Roles-module__-SQx9W__lightIcon",
  "reworkCard": "Roles-module__-SQx9W__reworkCard",
  "roleCard": "Roles-module__-SQx9W__roleCard",
  "roleCardBody": "Roles-module__-SQx9W__roleCardBody",
  "roleCardHeader": "Roles-module__-SQx9W__roleCardHeader",
  "roleCardTitle": "Roles-module__-SQx9W__roleCardTitle",
  "roleCards": "Roles-module__-SQx9W__roleCards",
  "roleDescription": "Roles-module__-SQx9W__roleDescription",
  "roleIcon": "Roles-module__-SQx9W__roleIcon",
  "roles": "Roles-module__-SQx9W__roles",
  "satisfactionCard": "Roles-module__-SQx9W__satisfactionCard",
  "subtitle": "Roles-module__-SQx9W__subtitle",
  "title": "Roles-module__-SQx9W__title",
  "titleSection": "Roles-module__-SQx9W__titleSection",
  "toggleIcon": "Roles-module__-SQx9W__toggleIcon",
  "whyBlock": "Roles-module__-SQx9W__whyBlock",
  "whyEyebrow": "Roles-module__-SQx9W__whyEyebrow",
  "whySection": "Roles-module__-SQx9W__whySection",
  "whySubtitle": "Roles-module__-SQx9W__whySubtitle",
  "whyTitle": "Roles-module__-SQx9W__whyTitle",
});
